
import React from 'react';
import { Input } from 'antd';

const ValoresInput = ({ value = '', onChange }) => {
  const formatValue = (raw) => {
    // Remove tudo que não é número
    const digitsOnly = raw.replace(/\D/g, '');

    // Evita quebra
    if (digitsOnly === '') return '';

    // Garante pelo menos 3 caracteres
    const padded = digitsOnly.padStart(3, '0');

    // Insere a vírgula antes dos dois últimos
    const inteiro = padded.slice(0, -2);
    const decimal = padded.slice(-2);

    return `${parseInt(inteiro)},${decimal}`;
  };

  const handleChange = (e) => {
    const raw = e.target.value;
    const formatted = formatValue(raw);
    onChange(formatted);
  };

  return (
    <Input
      value={value}
      onChange={handleChange}
      placeholder=""
      maxLength={6}
    />
  );
};

export default ValoresInput;
